module.exports = __webpack_public_path__ + "static/media/slider3.0084c903.jpg";